var map = {
	"./amazon.svg": 480,
	"./apple_music.svg": 72,
	"./backloggd.svg": 1260,
	"./deezer.svg": 3377,
	"./discogs.svg": 8260,
	"./github.svg": 5297,
	"./goodreads.svg": 7442,
	"./insta.svg": 2149,
	"./itch.svg": 8502,
	"./letterboxd.svg": 7673,
	"./letterboxd2.svg": 4969,
	"./letterboxd3.svg": 3752,
	"./spotify.svg": 7130,
	"./strava.svg": 4041,
	"./sunday_sites.svg": 8733,
	"./tidal.svg": 192,
	"./youtube.svg": 8903,
	"./yt_music.svg": 7827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7436;